const tabClassNames = `
  col-span-1
  text-xs sm:text-base
  text-center
  text-white font-semibold
  leading-8 h-8 sm:leading-10 sm:h-10
  rounded-t-md sm:rounded-t-xl
  border-solid
  cursor-pointer
`

function ActiveTab({ tab }) {
  const tabColor = tab.name === "時系列比較" ? "bg-green border-green" : "bg-main-blue border-main-blue"
  return (
    <button className={tabClassNames + ` ${tabColor}`}>
      {tab.name}
    </button>
  )
}

function NonActiveTab({ tab, onSelect = f => f }) {
  const tabGreen = "bg-green-200 border-green-200 hover:bg-green hover:border-green"
  const tabBlue = "bg-main-blue-100 border-main-blue-100 hover:bg-main-blue hover:border-main-blue"
  const tabColor = tab.name === "時系列比較" ? tabGreen : tabBlue
  return (
    <button
      className={tabClassNames + ` ${tabColor} transition`}
      onClick={() => onSelect({
        partId: tab.id,
        sectionId: "S01",
        elementId: "E01",
      })}
    >
      {tab.name}
    </button>
  )
}

function PartSelectionTab({ tab, isActive, onSelect = f => f }) {
  if (isActive) {
    return <ActiveTab tab={tab} />
  } else {
    return <NonActiveTab tab={tab} onSelect={onSelect} />
  }
}

export default PartSelectionTab;
